<template>
  <div id="base" v-if="accountData.i">
    <div class="app-container app-theme-white body-tabs-shadow fixed-sidebar fixed-header" :class="{'closed-sidebar':closed_sidebar,'sidebar-mobile-open':sidebar_mobile_open}">
        <div class="app-header header-shadow">
            <div class="app-header__logo">
                <div class="logo-src pointer" @click="$router.push('/')"></div>
                <div class="header__pane ml-auto">
                    <div @click="closed_sidebar=!closed_sidebar">
                        <button type="button" class="hamburger close-sidebar-btn hamburger--elastic" :class="{'is-active':closed_sidebar}">
                            <span class="hamburger-box">
                                <span class="hamburger-inner"></span>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="app-header__mobile-menu">
                <div @click="sidebar_mobile_open=!sidebar_mobile_open">
                    <button type="button" class="hamburger hamburger--elastic mobile-toggle-nav" :class="{'is-active':sidebar_mobile_open}">
                        <span class="hamburger-box">
                            <span class="hamburger-inner"></span>
                        </span>
                    </button>
                </div>
            </div>
            <div class="app-header__content" :class="{'header-mobile-open':header_mobile_open}">
                <div class="app-header-right">
                    <div class="header-btn-lg pr-0">
                        <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                                <div class="widget-content-left">
                                    <div class="btn-group">
                                        <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="p-0 btn">
                                            <img class="profile-image" v-lazy="premier+accountData.img" alt="user_image">
                                            <i class="fa fa-angle-down ml-2 opacity-8"></i>
                                        </a>
                                        <div tabindex="-1" role="menu" aria-hidden="true" class="dropdown-menu dropdown-menu-right search-wrapper">
                                            <button type="button" tabindex="0" class="dropdown-item">Update Profile</button>
                                            <button type="button" tabindex="0" class="dropdown-item">View Profile</button>
                                            <div tabindex="-1" class="dropdown-divider"></div>
                                            <button type="button" tabindex="0" class="dropdown-item" @click="$emit('logout')">Logout</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="widget-content-left ml-3 mr-3 header-user-info">
                                    <div class="widget-heading" v-html="accountData.n"></div>
                                    <div class="widget-subheading" v-html="accountData.u"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- .......................................................................... -->
        <div class="app-main">
              <div class="app-sidebar sidebar-shadow">
                  <div class="app-header__logo">
                      <div class="logo-src"></div>
                      <div class="header__pane ml-auto">
                          <div>
                              <button type="button" class="hamburger close-sidebar-btn hamburger--elastic">
                                  <span class="hamburger-box">
                                      <span class="hamburger-inner"></span>
                                  </span>
                              </button>
                          </div>
                      </div>
                  </div>
                  <div class="app-header__mobile-menu">
                      <div>
                          <button type="button" class="hamburger hamburger--elastic mobile-toggle-nav">
                              <span class="hamburger-box">
                                  <span class="hamburger-inner"></span>
                              </span>
                          </button>
                      </div>
                  </div>
                  <div class="app-header__menu">
                      <span>
                          <button type="button" class="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav" :class="{'active':header_mobile_open}">
                              <span class="btn-icon-wrapper">
                                  <i class="fa fa-ellipsis-v fa-w-6"></i>
                              </span>
                          </button>
                      </span>
                  </div>
                  <div class="scrollbar-sidebar">
                      <div class="app-sidebar__inner">
                          <ul class="vertical-nav-menu">
                              <li class="app-sidebar__heading">Profile</li>
                              <li>
                                  <a class="pointer">
                                      <i class="metismenu-icon pe-7s-note"></i>
                                      Update Profile
                                  </a>
                              </li>
                              <li>
                                  <a class="pointer">
                                      <i class="metismenu-icon pe-7s-display2"></i>
                                      View Profile
                                  </a>
                              </li>
                              <li class="app-sidebar__heading">Message</li>
                              <li>
                                  <a class="pointer">
                                      <i class="metismenu-icon pe-7s-mail"></i>
                                      Internal Message
                                  </a>
                              </li>
                              <li>
                                  <a class="pointer">
                                      <i class="metismenu-icon pe-7s-mail"></i>
                                      System Message
                                  </a>
                              </li>
                              <li class="app-sidebar__heading">Subscription</li>
                              <li>
                                  <a class="pointer">
                                      <i class="metismenu-icon pe-7s-rocket"></i>
                                      Upgrade Account
                                  </a>
                              </li>
                              <li>
                                  <a class="pointer">
                                      <i class="metismenu-icon pe-7s-rocket"></i>
                                      View Subscription
                                  </a>
                              </li>
                              <li class="app-sidebar__heading">Account</li>
                              <li>
                                  <a class="pointer">
                                      <i class="metismenu-icon pe-7s-lock"></i>
                                      Logout
                                  </a>
                              </li>
                          </ul>
                      </div>
                  </div>
              </div>

              <div class="app-main__outer">
                  <router-view :firstLoad="firstLoad" :talentData="talentData" :resumes="resumes" :images="images" />
                  <Footer/>
              </div>
        </div>
    </div>
  </div>
</template>

<script>
import Footer from './Footer.vue'

export default {
  name: 'TalentBase',
  components:{ Footer },
  props:{
    accountData: Object,
  },
  data(){
    return {
      settings_open: false,
      closed_sidebar: false,
      sidebar_mobile_open: false,
      header_mobile_open: false,
      menu_dropdown: false,
      loading: {},
      firstLoad: {},
      talentData: {},
      resumes: [],
      images: [],
    }
  },
  created(){
    if(!this.firstLoad.talentData){
      this.get_talentData();
    }
    if(!this.firstLoad.resumes){
      this.get_resumes();
    }
    if(!this.firstLoad.images){
      this.get_images();
    }
  },
  mounted(){
    // this.scrollDonwLoadMore();
  },
  methods: {
    async get_talentData(){
      if(this.loading.talentData || this.firstLoad.talentData)return false;

      this.loading.talentData = true;
      var url = this.api+'account/get_talentData/'+this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      data.set('i', this.accountData.i);
      data.set('u', this.accountData.u);
      data.set('c', this.accountData.c);
      await this.Axios.post(url, data)
      .then((response)=>{
        // console.log(response.data);
        if(response.data.error==0){
          this.talentData = response.data.data;
        }
      })
      .catch((error)=>{
        alert(error);
        console.error(error);
      })
      .then(() => {
        this.firstLoad.talentData = true;
        this.loading.talentData = false;
      })
    },
    async get_resumes(){
      if(this.loading.resumes || this.firstLoad.resumes)return false;

      this.firstLoad.resumes = true;
    },
    async get_images(){
      if(this.loading.images || this.firstLoad.images)return false;

      this.firstLoad.images = true;
    },
  }
}
</script>

<style scoped>
  img.profile-image{
    height: 40px!important;
    width: 40px!important;
    object-fit: cover!important;
    border-radius: 50%!important;
  }
</style>
